enum ErrorName {
    // front-end defined error
    FRONT_END_UNKNOWN_ERROR = '前端未知錯誤', // 1000
    CONNECTION_FAILED = '連線失敗', // 1001
    LOADING_FAILED = '載入失敗', // 1002
    CONNECTION_FAILED_IOS = '連線失敗(iOS背景執行)', // 1003
    TIMEOUT = '連線逾時', // 1004
    BROWSER_NOT_SUPPORTED = '裝置版本過低', // 1007
    /** insufficient balance error which is checked by client */
    INSUFFICIENT_BALANCE = '餘額不足', // 1005
    EXILED_FROM_TABLE = '踢出房間', // 1006
    REPORT_ERROR_TO_ACTIVITY = '異常回報', // 1900 外部或是瀏覽器政策導致的一些不影響遊戲運作的異常 但仍會透過Activity紀錄例外內容

    // back-end defined error
    /** insufficient balance error which is checked by server */
    INSUFFICIENT_BALANCE_SERVER = 'insufficient balance', // match Err field of ResponseDataType
    INSUFFICIENT_BALANCE_SERVER_2 = '5302', // match ErrorCode field of ResponseDataType
    /** It will happen when query history data too frequently */
    SYSTEM_BUSY = '4107',
    SYSTEM_BUSY2 = '5306', // used in slot game
    OPERATION_NOT_ALLOW = 'operate not allow',
}

export default ErrorName;
